/**
 * Demo Mode Indicator
 *
 * Shows a visual indicator when demo mode is active.
 * This component can be hidden via CSS for clean screenshots.
 */

import { isDemoModeActive } from '@/lib/demo-mode'

export function DemoModeIndicator() {
  if (!isDemoModeActive()) {
    return null
  }

  return (
    <div
      className="fixed bottom-4 right-4 z-50 flex items-center gap-2 rounded-full bg-violet-600 px-4 py-2 text-sm font-medium text-white shadow-lg transition-opacity hover:opacity-80"
      data-demo-indicator
    >
      <span className="relative flex h-2 w-2">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-violet-300 opacity-75"></span>
        <span className="relative inline-flex h-2 w-2 rounded-full bg-violet-200"></span>
      </span>
      Demo Mode
    </div>
  )
}

/**
 * CSS to hide the indicator for screenshots:
 *
 * [data-demo-indicator] {
 *   display: none !important;
 * }
 */
